import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { WebDispatch, setDataFilterCriteria, setTenantDataFilterCriteria } from '../actions';
import { WebReduxState } from '../reducers';
import WizardFilterPage from './WizardFilterPage';
import { WizardDescription, TenantWizardDescription } from './WizardDescription';

const Header = () => <FormattedMessage id="DataFilter.incidentType" defaultMessage="Category" />;

const optionsSelector = (state: WebReduxState) => state.inform.dataFilter.availableOptions.incidentTypes;
const selectedOptionsSelector = (state: WebReduxState) => state.inform.dataFilter.criteria.incidentTypes;
const handleSelectionChange = (dispatch: WebDispatch, options: string[]) => {
  dispatch(setDataFilterCriteria('incidentTypes', options));
};

const optionsSelectorTenantMode = (state: WebReduxState) => state.admin.tenants.availableOptions.incidentTypes;
const selectedOptionsSelectorTenantMode = (state: WebReduxState) => state.admin.tenants.tenantFilter.incidentTypes;
const handleSelectionChangeTenantMode = (dispatch: WebDispatch, options: string[]) => {
  dispatch(setTenantDataFilterCriteria('incidentTypes', options));
};

type Props = {
  tenantMode?: boolean;
};

export default function WizardIncidentTypesFilterPage({ tenantMode }: Props) {
  return (
    <WizardFilterPage
      HeaderComponent={Header}
      DescriptionComponent={tenantMode ? TenantWizardDescription : WizardDescription}
      optionsSelector={tenantMode ? optionsSelectorTenantMode : optionsSelector}
      selectedOptionsSelector={tenantMode ? selectedOptionsSelectorTenantMode : selectedOptionsSelector}
      onSelectionChanged={tenantMode ? handleSelectionChangeTenantMode : handleSelectionChange}
    />
  );
}
